"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowButton = exports.ButtonContainer = exports.IconContainer = exports.RemoveIcon = exports.ActiveFilterLabel = exports.ActiveFilterContainer = exports.ButtonApplyFilters = exports.ButtonText = exports.ClearButton = exports.SearchButton = exports.SearchInput = exports.SearchContainer = exports.Title = exports.TitleContainer = exports.TitleRow = exports.Row = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
const svg_components_1 = require("../../../assets/svg-components");
const Button_1 = __importDefault(require("../../../Components/Button"));
exports.Container = styled_components_1.default.div `
  width: ${props => (props.isMobile ? '100vw' : '100%')};
  padding-right: ${props => !props.isMobile && props.theme.spacing.m4}px;
  height: ${props => props.isMobile && '100%'};
  transition: ${props => props.theme.attributes.transition.fast};
  background-color: ${props => props.isMobile && props.theme.palette.BW_100};
  position: ${props => props.isMobile && 'fixed'};
  top: 0;
  left: 0;
  z-index: ${props => props.isMobile && props.theme.attributes.zIndex.header};
  padding: ${props => props.isMobile && `0 ${props.theme.constants.bootstrapGutter}px`};
  overflow-y: ${props => props.isMobile && 'auto'};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ isProductListing, isMobile, theme, isDesktopSmall }) => isProductListing &&
    isDesktopSmall &&
    `
    width: ${isMobile ? '100%' : '580px'};
    padding: 0 ${theme.spacing.s8}px;
    position: fixed;
    right: 0;
    left: auto;
    bottom: 0;
    top: auto;
    height: 100vh;
    overflow-y: auto;
    background-color: ${theme.palette.BW_100};
    z-index: ${theme.attributes.zIndex.lightbox};
  `}

 @media (${props => props.theme.breakpoints.lg}px <= width <= ${props => props.theme.breakpoints.xxl}px) {
  padding-right: 0px;
}
`;
exports.Row = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-top: ${props => props.theme.spacing.s4}px;
  gap: ${props => props.theme.spacing.s1}px;
`;
exports.TitleRow = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.TitleContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.medium};
  margin-right: ${props => props.theme.spacing.s2}px;
`;
exports.SearchContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  width: 100%;
  border: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-radius: ${props => props.theme.attributes.borderRadius.xs}px;
  margin: ${props => props.theme.spacing.m1}px 0;

  &:focus-within {
    border: 1px solid ${props => props.theme.palette.BLUE_100};
    outline: 1px solid ${props => props.theme.palette.BLUE_100};
  }
`;
exports.SearchInput = styled_components_1.default.input `
  border: none;
  width: 100%;
  font-size: ${props => props.theme.typography.size.defaultSize}px;
  line-height: ${props => props.theme.typography.lineHeight.s4}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  outline: none;
  ${(props) => props.shouldRemoveDefaultCancelButton &&
    `
  &::-webkit-search-cancel-button {
    display: none;
  }
  `}
`;
exports.SearchButton = styled_components_1.default.button `
border: none;
background: none;
  margin-left: ${props => props.theme.spacing.s3}px;
  svg > path {
    stroke: ${props => props.theme.palette.LIGHT_BLACK};
  }
`;
exports.ClearButton = styled_components_1.default.button `
border: none;
background: none;
  width: ${props => props.theme.constants.badgeSize.md};
  height: ${props => props.theme.constants.badgeSize.md};
  margin-left: ${props => props.theme.spacing.s3}px;
 svg > path {
    stroke: ${props => props.theme.palette.LIGHT_BLACK};
  }
  cursor: pointer;
`;
exports.ButtonText = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.BLUE_100};
  text-decoration: underline;
`;
exports.ButtonApplyFilters = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.BLUE_100};
  text-decoration: none;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid ${props => props.theme.palette.BLUE_100};
`;
exports.ActiveFilterContainer = styled_components_1.default.button `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.palette.BLUE_GRAY_20};
  padding: ${props => props.theme.spacing.s1}px ${props => props.theme.spacing.s3}px;
  border-radius: ${props => props.theme.attributes.borderRadius.xs}px;
  border: none;
  cursor: pointer;
`;
exports.ActiveFilterLabel = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.DARK_GRAY_80};
  line-height: ${props => props.theme.typography.lineHeight.s5}px;
`;
exports.RemoveIcon = (0, styled_components_1.default)(svg_components_1.CrossIcon) `
  margin-left: ${props => props.theme.spacing.s2}px;
  width: 10px;
  height: 10px;

  > path {
    fill: ${props => props.theme.palette.DARK_GRAY_80};
  }
`;
exports.IconContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: ${props => props.theme.attributes.zIndex.header};
  background-color: ${props => props.theme.palette.BW_100};
  height: ${props => props.theme.constants.filter.menuHeight}px;
  > svg {
    cursor: pointer;
  }
`;
exports.ButtonContainer = styled_components_1.default.div `
  margin: 0 -${props => props.theme.constants.bootstrapGutter}px;
  background-color: ${props => props.theme.palette.BW_100};
  padding: ${props => props.theme.spacing.s4}px;
  text-align: center;
  position: sticky;
  bottom: 0;
  box-shadow: ${props => props.theme.attributes.boxShadow.top};
`;
exports.ShowButton = (0, styled_components_1.default)(Button_1.default) `
  width: ${props => (props.isMobile ? '100%' : `${props.theme.constants.blockWidth.s0}px`)};
`;
exports.default = {
    Container: exports.Container,
    Row: exports.Row,
    TitleRow: exports.TitleRow,
    TitleContainer: exports.TitleContainer,
    Title: exports.Title,
    SearchContainer: exports.SearchContainer,
    SearchInput: exports.SearchInput,
    SearchButton: exports.SearchButton,
    ClearButton: exports.ClearButton,
    ButtonText: exports.ButtonText,
    ActiveFilterContainer: exports.ActiveFilterContainer,
    ActiveFilterLabel: exports.ActiveFilterLabel,
    RemoveIcon: exports.RemoveIcon
};
